import React from "react";
import { View, StyleSheet } from "react-native";
import Colors from "../../Resources/Color";
import IconEmptyView from "./IconEmptyView";

const OfflineView = () => {
  return (
    <View style={styles.container}>
      <IconEmptyView
        iconLibrary="Ionicons"
        iconName="cloud-offline"
        mainText="offlineViewTitle-string"
        subText="offlineViewDescription-string"
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    width: "100%",
    height: "100%",
    backgroundColor: Colors.whiteColor,
    justifyContent: "center",
    alignItems: "center",
  },
});

export default OfflineView;
